export enum BgColorPalette {
  PRIMARY = 'rgba(48, 48, 48, 1)',
  PRIMARY_HOVER = 'rgba(26, 26, 26, 1)',
  PRIMARY_ACTIVE = 'rgba(26, 26, 26, 1)',
  SECONDARY = 'rgba(241, 241, 241, 1)',
  SECONDARY_HOVER = 'rgba(235, 235, 235, 1)',
  SECONDARY_ACTIVE = 'rgba(227, 227, 227, 1)',
  INFO = 'rgba(145, 208, 255, 1)',
  INFO_HOVER = 'rgba(81, 192, 255, 1)',
  INFO_ACTIVE = 'rgba(0, 148, 213, 1)',
  SUCCESS = 'rgba(41, 132, 90, 1)',
  SUCCESS_HOVER = 'rgba(19, 111, 69, 1)',
  SUCCESS_ACTIVE = 'rgba(12, 81, 50, 1)',
  WARNING = 'rgba(255, 184, 0, 1)',
  WARNING_HOVER = 'rgba(178, 132, 0, 1)',
  WARNING_ACTIVE = 'rgba(255, 214, 164, 1)',
  CRITICAL = 'rgba(229, 28, 0, 1)',
  CRITICAL_HOVER = 'rgba(181, 38, 11, 1)',
  CRITICAL_ACTIVE = 'rgba(142, 31, 11, 1)',
  OVERLAY = 'rgba(0, 0, 0, 0.5)',
  OVERLAY_2 = 'rgba(0, 0, 0, 0.3)',
  SCREEN_LOCK = 'rgba(255, 255, 255, 0.5)',
  BADGE_INFO_BG = '#d5ebff',
  BADGE_INFO_COLOR = 'rgba(0, 58, 90, 1)',
}

export enum OrderStatusPalette {
  DELIVERED = '#30fa81ff',
  IN_TRANSIT = '#68aef0ff',
  OUT_FOR_DELIVERY = '#68aef0ff',
  INFORMATION_RECEIVED = '#e9b5b5ff',
  EXCEPTION = '#f5dc62ff',
  FAILED_ATTEMPT = '#f5dc62ff',
  EXPIRED = '#f7b86cff',
  PENDING = '#dfd0d0ff',
  COURIER_NOT_SUPPORTED = '#f7b86cff',
  OVER_QUOTA = '#f7a5a2ff',
  AVAILABLE_FOR_PICKUP = '#30fa81ff',
  NOT_FOUND = '#dfd0d0ff',
  COURIER_NOT_DETECTED = '#dfd0d0ff',
}
